import { createContext } from "react";
import { IPlansContext } from "./types";

export const PlansContext = createContext<IPlansContext>({
  plans: [],
  plansHierarchy: [],
});
